import React from "react";
import styled from "styled-components";

const H3 = styled.h3`
  margin: 0;
  align-items: center;
  font-weight: 900;
  font-size: 60px;
  font-family: "Roboto";
  margin-bottom: -15px;
`;
const MainContainer = styled.div`
  text-align: center;
  line-height: 30px;
  padding: 5.8rem 0rem 5rem 0rem;
  background-color: #fff;
`;

const TextWrappersmall = styled.text``;

function HiringSection() {
  return (
    <div>
      <MainContainer>
        <H3>We're Hiring!</H3>
        <br />
        <TextWrappersmall>
          Drop us a email at{" "}
          <a
            href="hr@metaspacelab.io"
            style={{ color: "#00A97C", fontWeight: "500" }}
          >
            hr@metaspacelab.io
          </a>
        </TextWrappersmall>
      </MainContainer>
    </div>
  );
}

export default HiringSection;
